
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bankingssc-faculty-list",
      function () {
        return require("private-next-pages/bankingssc-faculty-list/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bankingssc-faculty-list"])
      });
    }
  